import "./index.modules.css";
import React from "react";
import styles from "./index.modules.json";
import { getDefaultString } from "../../defaultString";
import SpmNodeNames from "../../spmd";
import { clickNode } from "../../utils/tracert";
var errorImg = "https://cdn.marmot-cloud.com/storage/iquic-mng/dev/common/png/bf3411ac-9e61-466d-bdd8-bf7c811abc8a.png";
var commonImg = "https://cdn.marmot-cloud.com/storage/iquic-mng/dev/common/png/a026113b-cb87-4447-b06c-229bfb276228.png";
var ErrorPage = function ErrorPage(props) {
  var state = props.state,
    queryVoucherInfo = props.queryVoucherInfo,
    iquicInfo = props.iquicInfo;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.img,
    src: state === "ERROR" ? errorImg : commonImg
  }), state === "INVENTORY_SHOREAGE" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, getDefaultString("inventoryShoreageTitle")), /*#__PURE__*/React.createElement("span", {
    className: styles.subtitle
  }, getDefaultString("inventoryShoreageSubtitle"))), state === "LANDING" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, getDefaultString("landingText"))), state === "ERROR" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, getDefaultString("defaultErrorTips")), /*#__PURE__*/React.createElement("div", {
    className: styles.button,
    style: {
      marginTop: "1.33rem"
    },
    onClick: function onClick() {
      clickNode(iquicInfo, SpmNodeNames.RefreshBtn.key, false, {});
      queryVoucherInfo();
    }
  }, getDefaultString("refreshText"))));
};
export default ErrorPage;
